module.exports = __webpack_public_path__ + "static/img/monster.2f151b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/monster.svg
// module id = 7+kH
// module chunks = 0